'use strict';

var h = require('react').createElement;

var _require = require('glamor'),
    css = _require.css;

var classnames = require('classnames');
var contextTypes = require('./context-types');
var parse = require('./parse');
var _config = require('./config'

/*
 * Higher order component
 * with support for `css` prop and style props
 */

);module.exports = function (_style) {
  return function (Component) {
    var AxsComponent = function AxsComponent(_props, context) {
      var config = Object.assign({}, _config, context.axs);
      var parsed = parse(_props, config);

      var style = Object.assign({}, _style, parsed.css);
      var hasStyle = Object.keys(style).length;

      var cn = hasStyle ? css(style).toString() : null;

      var props = Object.assign({}, parsed, {
        className: classnames(parsed.className, cn)
      });

      var tag = props.is || Component;

      delete props.css;
      delete props.is;

      return h(tag, props);
    };

    AxsComponent.contextTypes = contextTypes;
    AxsComponent.displayName = Component.displayName;

    return AxsComponent;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/axs.js
// module id = 19
// module chunks = 0